import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import type GridConfiguration from '../types/GridConfiguration'

export const EarlySettlementCasesConfiguration: GridConfiguration = {
  columns: [
    {
      field: 'closed_date',
      header: 'Closed Date',
      type: 'date',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
    },
    {
      field: 'funded_date',
      header: 'Funded Date',
      type: 'date',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
    },
    {
      field: 'agreement_number',
      header: 'Agreement Number',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'type_of_closure',
      header: 'Type of Closure',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'contract_type',
      header: 'Contract Type',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'days_open',
      header: 'Days Open',
      type: 'number',
    },
    {
      field: 'term',
      header: 'Term',
      type: 'number',
    },
    {
      field: 'registration',
      header: 'Registration',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'customer_name',
      header: 'Customer Name',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'amount_financed',
      header: 'Amount Financed',
      type: 'currency',
    },
  ],
  settings: [
    { name: 'showDownloadDocument', value: false },
    { name: 'showDownloadSpreadsheet', value: true },
    { name: 'showMonthFilter', value: false },
    { name: 'showYearFilter', value: true },
    { name: 'showColumnSelect', value: true },
    { name: 'sortField', value: 'closed_date' },
  ],
}
